import React, { useState, useEffect } from "react"
import { Modal, Card } from "antd"
import GridFiles from "components/Common/GridFilesAnt"
import { enumToArray } from "helpers/service_helper"
import { FileGasProjectTypeAdmin } from "models/types/file-gas-project-type-admin"

export const ProjectFiles = ({ rowData, mainProps, setErrorMessage }) => {
  const { lstGasProjectFiles } = mainProps
  const [open, setOpen] = useState(false)
  const [fileGasProjectTypes, setFileGasProjectTypes] = useState([])
  useEffect(() => {
    setFileGasProjectTypes(enumToArray(FileGasProjectTypeAdmin))
  }, [])


  return (
    <>
      <a
        style={{ color: '#1890ff', cursor: 'pointer' }}
        onClick={async () => {
          const { onGetProjectFiles } = mainProps

          await onGetProjectFiles(rowData.id)

          setOpen(true)
        }}
      >
        فایلها
      </a>
      <Modal
        open={open}
        title={"مدیریت فایل های پرونده: " + rowData.fileNumber}
        onCancel={() => setOpen(false)}
        footer={null}
        width={600}
        styles={{ body: { padding: 0 } }}
      >
        <Card bordered={false} styles={{ body: { padding: 0 } }}>
          <div style={{ maxHeight: 400, overflowY: 'auto' }}>
            <GridFiles lstGasProjectFiles={lstGasProjectFiles} props={mainProps} />
          </div>
        </Card>
      </Modal>
    </>
  )
}
